module.exports = __webpack_public_path__ + "static/the-chirpyest-mobile-5193c74f992bd36cdbb5f92db489bc0e.png";